import { PcCase, MonitorPlay, LucideIcon } from 'lucide-react';
import type { ScopeUnitDto } from '@repo/shared/dtos/analytics/ScopeFilterDto';
import type { UsedExperienceDto } from '@repo/shared/dtos/analytics/ExperienceFilterDto';
import { API_ENDPOINTS } from './endpoints';

export interface FilterConfig<T> {
  title: string;
  icon: LucideIcon;
  endpoint: string;
  getId: (item: T) => number;
  getDisplayName: (item: T) => string;
  getSubtext?: (item: T) => string;
  variant: 'simple' | 'advanced';
}

export const FILTER_CONFIGS = {
  units: {
    title: 'Units',
    icon: PcCase,
    endpoint: API_ENDPOINTS.SCOPE_FILTER,
    getId: (unit: ScopeUnitDto) => parseInt(unit.unitid),
    getDisplayName: (unit: ScopeUnitDto) => unit.unitdescription || `Unit ${unit.unitid}`,
    variant: 'simple' as const,
  },
  experiences: {
    title: 'Sessions',
    icon: MonitorPlay,
    endpoint: API_ENDPOINTS.USED_EXPERIENCES,
    getId: (experience: UsedExperienceDto) => experience.experienceId,
    getDisplayName: (experience: UsedExperienceDto) => experience.experienceTitle,
    variant: 'simple' as const,
  },
} as const;

export type FilterType = keyof typeof FILTER_CONFIGS;
